import { useState } from 'react';
import { IconButton, Popover, Tooltip } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

/**
 * Menu「その他メニュー ⋮」dùng chung cho toolbar message ở Chatthread (chat ticket + chat knowledge).
 *
 * @param {Array<{ key: string, label: string, visible?: boolean, disabled?: boolean, onClick: Function }>} actions
 *        Danh sách action. Chỉ render item có visible !== false.
 */
export default function MessageMoreMenu({ actions = [], onOpenChange }) {
    useTranslationSubscription();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const visibleActions = actions.filter(action => action && action.visible !== false);
    if (visibleActions.length === 0) return null;

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
        onOpenChange?.(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        onOpenChange?.(false);
    };

    const handleSelect = action => {
        if (action.disabled) return;
        handleClose();
        action.onClick?.();
    };

    return (
        <>
            <Tooltip title={trI18n('CHATPOST-MORE-MENU-TOOLTIP')} placement="top" arrow>
                <IconButton
                    aria-label="more"
                    aria-haspopup="true"
                    aria-controls={open ? 'chatpost-more-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleOpen}
                    className="chatpost-more-menu-btn"
                >
                    <img src="/assets/image/icon-option-list.svg" alt="" />
                </IconButton>
            </Tooltip>
            <Popover
                id="chatpost-more-menu"
                className="navTabs-drop navTabs-drop--changePd chatpost-more-menu"
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <ul className="chatpost-more-menu-list">
                    {visibleActions.map(action => (
                        <li
                            key={action.key}
                            className={action.disabled ? 'disabled' : ''}
                            onClick={() => handleSelect(action)}
                        >
                            {action.icon && (
                                <span className="chatpost-more-menu-icon">
                                    <img src={action.icon} alt="" />
                                </span>
                            )}
                            <span className="chatpost-more-menu-label">{action.label}</span>
                        </li>
                    ))}
                </ul>
            </Popover>
        </>
    );
}
